<div class="container-fluid spacer-top-navigation">
  <div class="container leverage-products">
    <div class="row row--primary">
      <div class="col-12 pl-0 mb-3">
        <a [routerLink]="backLink" class="link-secondary font-default">
          <svg class="icon icon-21"><use xlink:href="/assets/img/svgs/svgset.svg#arrow-left" /></svg>
          {{ 'leverage-products.back' | transloco }}
        </a>
      </div>
      <div class="tile col-12">
        <leverage-products
          [isin]="isin"
          [name]="name"
          [isStandalone]="true"
          [investmentType]="investmentType"
          [editLeverage]="editLeverage"
        />
      </div>
    </div>
  </div>
</div>
